import { find } from "lodash";
export function findValue(arr, key) {
  return find(arr, { locale_key: key })?.locale_value || '';
}

export const OFFICIAL_PRICE_CHANNEL_GROUP_IDS = new Set([4, 5, 10]);

export function isOfficialPriceChannelGroup(channelGroupId) {
  return OFFICIAL_PRICE_CHANNEL_GROUP_IDS.has(channelGroupId);
}
